<p>dialog-edit-mood works!</p>
